import { render, staticRenderFns } from "./ProductAttributeForm.vue?vue&type=template&id=dec7a5ce&lang=pug&"
import script from "./ProductAttributeForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProductAttributeForm.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ProductAttributeForm.vue?vue&type=style&index=0&id=dec7a5ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports